import React, { Component } from 'react';
import Img from 'gatsby-image';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './style.module.css';

class Garment extends Component {
  componentWillMount() {
    this.resetComponent()
  }

  resetComponent = () => {
    this.setState({ hover: false })
  }

  handleMouseEnter = () => {
    this.setState({ hover: true })
  }

  handleMouseLeave = () => {
    this.setState({ hover: false })
  }

  render() {
    const { hover } = this.state;
    const { image } = this.props;

    return (
      <li 
        className={styles.container} 
        onClick={this.props.onClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        >
        <Img 
          fluid={image.fluid} 
          title={this.props.name} 
          alt={this.props.name}
          className={
            cx({[styles.hover]: hover ? true:false})
          } />
      </li>
    );
  }
}

Garment.propTypes = {
  image: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
};

export default Garment;